import React, { useState } from "react";
import { MainScreen } from "../main-screen/main-screen";
import { InfoUnit } from "../info-unit/info-unit";
import { InfoUnitMobiles } from "../info-unit/info-unit-mobiles";
import "../../constructor/common.css";
import { FeatureBlock } from "../feature-block/feature-block";
import { AboutBlock } from "../about-block/about-block";
import { ContentBlock } from "../content-block/content-block";
import { Footer } from "../../footer/footer";
import MarkdownRenderer from "../../common/MarkdownRenderer";
import Cases from "../../cases/cases";
import c1 from "../../cases/img/boostpad-case.png";
import c2 from "../../cases/img/mini-case3.jpg";
import c3 from "../../cases/img/mini-case7.jpg";
import "./styles.css";

import ContactUsModal from "../../modal/contact-us";
import HtmlRenderer from "../../../HtmlRenderer.js";

// import { Reviews } from "../../reviews/reviews";

export const LeadMagnit1 = () => {
	const navigate = useNavigate();

	document.title =
		"4 критические UX-ошибки: почему криптопроекты теряют клиентов ";
	document.getElementsByTagName("META")[2].content =
		"Ошибки в UX могут стоить вашему криптопроекту инвестиций и пользователей. Узнайте 4 критические проблемы, из-за которых проекты теряют деньги.";

	document.getElementsByTagName("META")[3].content =
		"UX дизайн Web3, UX аудит криптопроектов, UX блокчейн, юзабилити криптопроектов, UX для Web3, ошибки в UX, UX для блокчейн-проектов, проблемы UX в крипте";

	return (
		<div className="leadmagnit1">
			<MainScreen
				backgroundColor="linear-gradient(180deg, #FFF 0%, #FFF 5.95%, #FFF 9.86%, #FBFCFE 15.18%, #F8FAFC 20.32%, #F4F7FB 27.41%, #F4F7FB 33.62%, #F4F7FB 40.18%, #F0F5F9 44.79%, #F0F5F9 51.17%, #F0F5F9 56.85%, #E9F0F7 63.41%, #E9F0F7 70.88%, #E9F0F7 78.62%, #E9F0F7 88.21%, #E9F0F7 100%)"
				titleColor="#242323"
				textColor="#242323"
				isHeaderOnDark
			/>

			<HtmlRenderer file="lead-magnit-1" />

			<section className="section" id="project">
				<div className="container">
					<div className="cases__container">
						<h4 className="cases__title">Наши кейсы</h4>
						<div className="cases__grid">
							<div className="leadmagnit__case">
								<a
									href="/web3-eq-product-page"
									target="_blank"
									className="cases__item"
									rel="noreferrer"
								>
									<img
										src={c2}
										alt="Децентрализованная крипто биржа универсальных инструментов"
									/>
								</a>
								<div>
									Децентрализованная крипто биржа универсальных инструментов
								</div>
							</div>

							<div className="leadmagnit__case">
								<a
									href="/boostpad-ux-ui-launchpad"
									target="_blank"
									className="cases__item"
									rel="noreferrer"
								>
									<img src={c1} alt="Крипто лаунчпад платформа" />
								</a>
								<div>Крипто лаунчпад платформа</div>
							</div>

							<div className="leadmagnit__case">
								<a
									href="/invest"
									target="_blank"
									className="cases__item"
									rel="noreferrer"
								>
									<img src={c3} alt="Платформа для разумных инвестиций" />
								</a>
								<div>Платформа для&nbsp;разумных инвестиций</div>
							</div>
						</div>

						<div className="leadmagnit1__text">
							Планируете запускать web3&nbsp;проект?
							Или&nbsp;уже&nbsp;в&nbsp;процессе разработки, но&nbsp;хотите
							провести аудит и&nbsp;выявить слабые места?
							<br />
							Оставьте заявку&nbsp;— и&nbsp;мы&nbsp;свяжемся с&nbsp;вами
							в&nbsp;течение рабочего&nbsp;дня. Обсудим ваш&nbsp;проект,
							подберём оптимальное решение и&nbsp;поможем сделать интерфейс
							удобным, безопасным и&nbsp;понятным.
						</div>

						<button
							className="action__button"
							onClick={() => navigate(`?modal`)}
						>
							Обсудить проект
						</button>
					</div>
				</div>
			</section>

			<section className="design" id="design">
				<div className="container" id="contacts">
					<Footer backgroundColor="transparent" />
				</div>
			</section>

			<ContactUsModal listId={88833} />
		</div>
	);
};
